export default __webpack_public_path__ + "static/media/phones.740643aa.png";